export function initCardScroll() {
    const scrollContainers = document.querySelectorAll('.compact-card-list-row');
    let activeContainer = null;
    const handleMouseMove = (e) => {
        if (!activeContainer || !activeContainer.isDown)
            return;
        e.preventDefault();
        const x = e.pageX - activeContainer.element.offsetLeft;
        const walk = (x - activeContainer.startX) * 2;
        activeContainer.element.scrollLeft = activeContainer.scrollLeft - walk;
    };
    const handleMouseUp = () => {
        if (activeContainer) {
            activeContainer.isDown = false;
            activeContainer = null;
        }
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    scrollContainers.forEach(container => {
        const handleMouseDown = (e) => {
            if (container.scrollWidth <= container.clientWidth)
                return;
            if (e.button !== 0)
                return;
            activeContainer = {
                element: container,
                isDown: true,
                startX: e.pageX - container.offsetLeft,
                scrollLeft: container.scrollLeft
            };
        };
        const handleWheel = (e) => {
            if (container.scrollWidth <= container.clientWidth)
                return;
            if (e.deltaY !== 0) {
                e.preventDefault();
                container.scrollLeft += e.deltaY;
            }
        };
        container.addEventListener('mousedown', handleMouseDown);
        container.addEventListener('wheel', handleWheel, { passive: false });
    });
}
